import Header from './components/Header';
import Hero from './components/Hero';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <UpdatesSection />
        <ContactSection />
        <CarouselSection />
        <FeaturesSection />
        <IndexSection />
        <AppSection />
        <FaqSection />
        <TopicsSection />
        <CommentsSection />
        <CardsSection />
        <AboutSection />
        <RankingSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}